//current code
// import React, { useState } from "react";
// import { Link, useLocation } from "react-router-dom";

// import AppBar from "@material-ui/core/AppBar";
// import { useMediaQuery, useTheme } from "@material-ui/core";
// import IconButton from "@material-ui/core/IconButton";
// import Toolbar from "@material-ui/core/Toolbar";
// import Menu from "@material-ui/core/Menu";
// import MenuItem from "@material-ui/core/MenuItem";
// import Typography from "@material-ui/core/Typography";

// import MenuIcon from "@material-ui/icons/Menu";

// import logo from "url:../../assets/images/m10coderlogo.svg";
// import {
//   DEVELOPER_TAB,
//   HOME_TAB,
//   PERCEPTIVITI,
//   PRICING_STATUS,
//   PRICING_TAB,
//   SEARCH_TAB,
// } from "../../utils/constants";

// export default function CustomNavbar() {
//   const { pathname } = useLocation();

//   const theme = useTheme();
//   const [anchor, setAnchor] = useState(null);
//   const open = Boolean(anchor);

//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//   const handleMenu = (event) => {
//     setAnchor(event.currentTarget);
//   };

//   const handleLinkClick = () => {
//     window.location = PERCEPTIVITI;
//   };

//   let tabName;
//   if (pathname === "/") {
//     tabName = HOME_TAB;
//     document.title = "Home - mCoder";
//   } 
//   // else if (pathname === "/developer") {
//   //   tabName = DEVELOPER_TAB;
//   //   document.title = "Developer - i10Coder";
//   // } 
//   else if (pathname === "/pricing") {
//     tabName = PRICING_TAB;
//     document.title = "Pricing - mCoder";
//   } else if (pathname === "/search") {
//     tabName = SEARCH_TAB;
//     document.title = "Search - mCoder";
//   } else {
//     tabName = HOME_TAB;
//   }

//   return (
//     <>
//       <AppBar
//         position="sticky"
//         className="custom-navbar "
//         style={{ backgroundColor: "white", boxShadow: "none" }}
//       >
//         <Toolbar
//           className="d-flex justify-content-between"
//           style={{ padding: "0" }}
//         >
//           <div className="d-flex ">
//             <Link to="/home">
//               <img
//                 style={{ verticalAlign: "top" }}
//                 src={logo}
//                 height="30"
//                 alt=""
//               />
//             </Link>

//             {/* <h5 style={{ color: "black" }}>i10Coder</h5> */}
//           </div>
//           {isMobile ? (
//             <>
//               <IconButton edge="start" aria-label="menu" onClick={handleMenu}>
//                 <MenuIcon />
//               </IconButton>
//               <Menu
//                 id="menu-appbar"
//                 anchorEl={anchor}
//                 anchorOrigin={{
//                   vertical: "top",
//                   horizontal: "right",
//                 }}
//                 KeepMounted
//                 transformOrigin={{
//                   vertical: "top",
//                   horizontal: "right",
//                 }}
//                 open={open}
//               >
//                 <MenuItem
//                   onClick={() => setAnchor(null)}
//                   component={Link}
//                   to="/"
//                 >
//                   <Typography variant="h6"> Home</Typography>
//                 </MenuItem>
//                 {/* <MenuItem
//                   onClick={() => setAnchor(null)}
//                   component={Link}
//                   to="/developer"
//                 >
//                   <Typography variant="h6"> Developer </Typography>
//                 </MenuItem> */}
//                 {PRICING_STATUS ? (
//                   <MenuItem
//                     onClick={() => setAnchor(null)}
//                     component={Link}
//                     to="/pricing"
//                   >
//                     <Typography variant="h6"> Pricing</Typography>
//                   </MenuItem>
//                 ) : (
//                   ""
//                 )}
//                 <MenuItem
//                   onClick={() => {
//                     setAnchor(null);
//                     handleLinkClick();
//                   }}
//                 >
//                   <Typography variant="h6"> About </Typography>
//                 </MenuItem>
//               </Menu>
//             </>
//           ) : (
//             <>
//               <div className="navbar" style={{ display: "flex", gap: "24px" }}>
//                 <div>
//                   <Link
//                     className={
//                       tabName === HOME_TAB
//                         ? "nav-link text-uppercase active"
//                         : "nav-link text-uppercase"
//                     }
//                     to="/home"
//                   >
//                     Home
//                   </Link>
//                 </div>
//                 {/* <div>
//                   <Link
//                     className={
//                       tabName === DEVELOPER_TAB
//                         ? "nav-link text-uppercase active"
//                         : "nav-link text-uppercase"
//                     }
//                     to="/developer"
//                   >
//                     Developer
//                   </Link>
//                 </div> */}
//                 {PRICING_STATUS ? (
//                   <div>
//                     <Link
//                       className={
//                         tabName === PRICING_TAB
//                           ? "nav-link text-uppercase active"
//                           : "nav-link text-uppercase"
//                       }
//                       to="/pricing"
//                     >
//                       Pricing
//                     </Link>
//                   </div>
//                 ) : (
//                   ""
//                 )}
//                 <div
//                   tabIndex="0"
//                   role="button"
//                   className="nav-link text-uppercase"
//                   variant="text"
//                   onClick={handleLinkClick}
//                   onKeyDown={(event) => {
//                     if (event.key === "Enter") {
//                       handleLinkClick();
//                     }
//                   }}
//                 >
//                   About
//                 </div>
//               </div>
//             </>
//           )}
//         </Toolbar>
//       </AppBar>
//     </>
//   );
// }





















//test code for preferences
// import React, { useState, useEffect } from "react";
// import { Link, useLocation } from "react-router-dom";
// import AppBar from "@material-ui/core/AppBar";
// import { useMediaQuery, useTheme } from "@material-ui/core";
// import IconButton from "@material-ui/core/IconButton";
// import Toolbar from "@material-ui/core/Toolbar";
// import Menu from "@material-ui/core/Menu";
// import MenuItem from "@material-ui/core/MenuItem";
// import Typography from "@material-ui/core/Typography";
// import Radio from "@material-ui/core/Radio";
// import FormControlLabel from "@material-ui/core/FormControlLabel";
// import MenuIcon from "@material-ui/icons/Menu";
// import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
// import logo from "url:../../assets/images/m10coderlogo.svg";
// import {
//   DEVELOPER_TAB,
//   HOME_TAB,
//   PERCEPTIVITI,
//   PRICING_STATUS,
//   PRICING_TAB,
//   SEARCH_TAB,
// } from "../../utils/constants";
// import { useSearch } from "../../context/searchContext";

// export default function CustomNavbar() {
//   const { pathname } = useLocation();
//   const theme = useTheme();
//   const [anchor, setAnchor] = useState(null);
//   const [prefAnchor, setPrefAnchor] = useState(null);
//   const open = Boolean(anchor);
//   const prefOpen = Boolean(prefAnchor);
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//   const { icdFormat, setIcdFormat, cptFormat, setCptFormat } = useSearch();

//   const handleMenu = (event) => {
//     setAnchor(event.currentTarget);
//   };

//   const handlePrefMenu = (event) => {
//     setPrefAnchor(event.currentTarget);
//   };

//   const handleLinkClick = () => {
//     window.location = PERCEPTIVITI;
//   };

//   const handleIcdChange = (event) => {
//   const newFormat = event.target.value;
//   console.log("ICD Format changed to:", newFormat);
//   setIcdFormat(newFormat);
// };

// const handleCptChange = (event) => {
//   const newFormat = event.target.value;
//   console.log("CPT Format changed to:", newFormat);
//   setCptFormat(newFormat);
// };

//   let tabName;
//   if (pathname === "/") {
//     tabName = HOME_TAB;
//     document.title = "Home - mCoder";
//   } else if (pathname === "/pricing") {
//     tabName = PRICING_TAB;
//     document.title = "Pricing - mCoder";
//   } else if (pathname === "/search") {
//     tabName = SEARCH_TAB;
//     document.title = "Search - mCoder";
//   } else {
//     tabName = HOME_TAB;
//   }

//   const preferencesMenu = (
//     <Menu
//       id="pref-menu"
//       anchorEl={prefAnchor}
//       open={prefOpen}
//       onClose={() => setPrefAnchor(null)}
//       anchorOrigin={{
//         vertical: "top",
//         horizontal: "right",
//       }}
//       transformOrigin={{
//         vertical: "top",
//         horizontal: "right",
//       }}
//     >
//       <MenuItem disabled>
//         <Typography variant="subtitle1">Output Format</Typography>
//       </MenuItem>
//       <MenuItem>
//         <div>
//           <Typography variant="subtitle2">ICD10 Output format</Typography>
//           <FormControlLabel
//             control={
//               <Radio
//                 checked={icdFormat === "ICD10-CM"}
//                 onChange={handleIcdChange}
//                 value="ICD10-CM"
//                 color="primary"
//               />
//             }
//             label="ICD 10 - CM"
//           />
//           <FormControlLabel
//             control={
//               <Radio
//                 checked={icdFormat === "ICD10-AM"}
//                 onChange={handleIcdChange}
//                 value="ICD10-AM"
//                 color="primary"
//               />
//             }
//             label="ICD 10 - AM"
//           />
//         </div>
//       </MenuItem>
//       <MenuItem>
//         <div>
//           <Typography variant="subtitle2">Procedure Codes</Typography>
//           <FormControlLabel
//             control={
//               <Radio
//                 checked={cptFormat === "CPT/HCPCS"}
//                 onChange={handleCptChange}
//                 value="CPT/HCPCS"
//                 color="primary"
//               />
//             }
//             label="CPT/HCPCS"
//           />
//           <FormControlLabel
//             control={
//               <Radio
//                 checked={cptFormat === "Nphies"}
//                 onChange={handleCptChange}
//                 value="Nphies"
//                 color="primary"
//               />
//             }
//             label="Nphies code"
//           />
//         </div>
//       </MenuItem>
//     </Menu>
//   );

//   return (
//     <>
//       <AppBar
//         position="sticky"
//         className="custom-navbar"
//         style={{ backgroundColor: "white", boxShadow: "none" }}
//       >
//         <Toolbar
//           className="d-flex justify-content-between"
//           style={{ padding: "0" }}
//         >
//           <div className="d-flex">
//             <Link to="/home">
//               <img style={{ verticalAlign: "top" }} src={logo} height="30" alt="" />
//             </Link>
//           </div>
//           {isMobile ? (
//             <>
//               <IconButton edge="start" aria-label="menu" onClick={handleMenu}>
//                 <MenuIcon />
//               </IconButton>
//               <Menu
//                 id="menu-appbar"
//                 anchorEl={anchor}
//                 anchorOrigin={{ vertical: "top", horizontal: "right" }}
//                 keepMounted
//                 transformOrigin={{ vertical: "top", horizontal: "right" }}
//                 open={open}
//                 onClose={() => setAnchor(null)}
//               >
//                 <MenuItem component={Link} to="/">
//                   <Typography variant="h6">Home</Typography>
//                 </MenuItem>
//                 {PRICING_STATUS && (
//                   <MenuItem component={Link} to="/pricing">
//                     <Typography variant="h6">Pricing</Typography>
//                   </MenuItem>
//                 )}
//                 <MenuItem onClick={handleLinkClick}>
//                   <Typography variant="h6">About</Typography>
//                 </MenuItem>
//                 <MenuItem onClick={handlePrefMenu}>
//                   <Typography variant="h6">Preferences</Typography>
//                   <ArrowDropDownIcon style={{ marginLeft: "8px", fontSize: "20px" }} />
//                 </MenuItem>
//               </Menu>
//               {preferencesMenu}
//             </>
//           ) : (
//             <div className="navbar" style={{ display: "flex", gap: "24px" }}>
//               <div>
//                 <Link
//                   className={
//                     tabName === HOME_TAB
//                       ? "nav-link text-uppercase active"
//                       : "nav-link text-uppercase"
//                   }
//                   to="/home"
//                 >
//                   Home
//                 </Link>
//               </div>
//               {PRICING_STATUS && (
//                 <div>
//                   <Link
//                     className={
//                       tabName === PRICING_TAB
//                         ? "nav-link text-uppercase active"
//                         : "nav-link text-uppercase"
//                     }
//                     to="/pricing"
//                   >
//                     Pricing
//                   </Link>
//                 </div>
//               )}
//               <div
//                 tabIndex="0"
//                 role="button"
//                 className="nav-link text-uppercase"
//                 onClick={handleLinkClick}
//                 onKeyDown={(event) => {
//                   if (event.key === "Enter") handleLinkClick();
//                 }}
//               >
//                 About
//               </div>
//               <div>
//                 <div
//                   tabIndex="0"
//                   role="button"
//                   className="nav-link text-uppercase"
//                   onClick={handlePrefMenu}
//                   onKeyDown={(event) => {
//                     if (event.key === "Enter") handlePrefMenu(event);
//                   }}
//                   style={{ display: "flex", alignItems: "center" }}
//                 >
//                   Preferences
//                   <ArrowDropDownIcon style={{ marginLeft: "8px", fontSize: "20px" }} />
//                 </div>
//                 {preferencesMenu}
//               </div>
//             </div>
//           )}
//         </Toolbar>
//       </AppBar>
//     </>
//   );
// }















import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import AppBar from "@material-ui/core/AppBar";
import { useMediaQuery, useTheme } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import Toolbar from "@material-ui/core/Toolbar";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Typography from "@material-ui/core/Typography";
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import MenuIcon from "@material-ui/icons/Menu";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import logo from "url:../../assets/images/m10coderlogo.svg";
import {
  DEVELOPER_TAB,
  HOME_TAB,
  PERCEPTIVITI,
  PRICING_STATUS,
  PRICING_TAB,
  SEARCH_TAB,
} from "../../utils/constants";
import { useSearch } from "../../context/searchContext";

export default function CustomNavbar() {
  const { pathname } = useLocation();
  const theme = useTheme();
  const [anchor, setAnchor] = useState(null);
  const [prefAnchor, setPrefAnchor] = useState(null);
  const open = Boolean(anchor);
  const prefOpen = Boolean(prefAnchor);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { icdFormat, setIcdFormat } = useSearch();

  const handleMenu = (event) => {
    setAnchor(event.currentTarget);
  };

  const handlePrefMenu = (event) => {
    setPrefAnchor(event.currentTarget);
  };

  const handleLinkClick = () => {
    window.location = PERCEPTIVITI;
  };

  const handleIcdChange = (event) => {
    const newFormat = event.target.value;
    console.log("ICD Format changed to:", newFormat);
    setIcdFormat(newFormat);
  };

  let tabName;
  if (pathname === "/") {
    tabName = HOME_TAB;
    document.title = "Home - mCoder";
  } else if (pathname === "/pricing") {
    tabName = PRICING_TAB;
    document.title = "Pricing - mCoder";
  } else if (pathname === "/search") {
    tabName = SEARCH_TAB;
    document.title = "Search - mCoder";
  } else if (pathname === "/developer") {
    tabName = DEVELOPER_TAB;
    document.title = "Developer - mCoder";
  } else {
    tabName = HOME_TAB;
  }

  const preferencesMenu = (
    <Menu
      id="pref-menu"
      anchorEl={prefAnchor}
      open={prefOpen}
      onClose={() => setPrefAnchor(null)}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
    >
      <MenuItem disabled>
        <Typography variant="subtitle1">Output Format</Typography>
      </MenuItem>
      <MenuItem>
        <div>
          <Typography variant="subtitle2">ICD10 Output format</Typography>
          <FormControlLabel
            control={
              <Radio
                checked={icdFormat === "ICD10-CM"}
                onChange={handleIcdChange}
                value="ICD10-CM"
                color="primary"
              />
            }
            label="ICD 10 - CM"
          />
          <FormControlLabel
            control={
              <Radio
                checked={icdFormat === "ICD10-AM"}
                onChange={handleIcdChange}
                value="ICD10-AM"
                color="primary"
              />
            }
            label="ICD 10 - AM"
          />
        </div>
      </MenuItem>
      <MenuItem disabled>
        <Typography variant="subtitle2">Procedure Codes: ICD-10-PCS</Typography>
      </MenuItem>
    </Menu>
  );

  return (
    <>
      <AppBar
        position="sticky"
        className="custom-navbar"
        style={{ backgroundColor: "white", boxShadow: "none" }}
      >
        <Toolbar
          className="d-flex justify-content-between"
          style={{ padding: "0" }}
        >
          <div className="d-flex">
            <Link to="/home">
              <img style={{ verticalAlign: "top" }} src={logo} height="30" alt="" />
            </Link>
          </div>
          {isMobile ? (
            <>
              <IconButton edge="start" aria-label="menu" onClick={handleMenu}>
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchor}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                keepMounted
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                open={open}
                onClose={() => setAnchor(null)}
              >
                <MenuItem component={Link} to="/">
                  <Typography variant="h6">Home</Typography>
                </MenuItem>
                {PRICING_STATUS && (
                  <MenuItem component={Link} to="/pricing">
                    <Typography variant="h6">Pricing</Typography>
                  </MenuItem>
                )}
                <MenuItem onClick={handleLinkClick}>
                  <Typography variant="h6">About</Typography>
                </MenuItem>
                <MenuItem component={Link} to="/developer">
                  <Typography variant="h6">Developer</Typography>
                </MenuItem>
                <MenuItem onClick={handlePrefMenu}>
                  <Typography variant="h6">Preferences</Typography>
                  <ArrowDropDownIcon style={{ marginLeft: "8px", fontSize: "20px" }} />
                </MenuItem>
              </Menu>
              {preferencesMenu}
            </>
          ) : (
            <div className="navbar" style={{ display: "flex", gap: "24px" }}>
              <div>
                <Link
                  className={
                    tabName === HOME_TAB
                      ? "nav-link text-uppercase active"
                      : "nav-link text-uppercase"
                  }
                  to="/home"
                >
                  Home
                </Link>
              </div>
              {PRICING_STATUS && (
                <div>
                  <Link
                    className={
                      tabName === PRICING_TAB
                        ? "nav-link text-uppercase active"
                        : "nav-link text-uppercase"
                    }
                    to="/pricing"
                  >
                    Pricing
                  </Link>
                </div>
              )}
              <div
                tabIndex="0"
                role="button"
                className="nav-link text-uppercase"
                onClick={handleLinkClick}
                onKeyDown={(event) => {
                  if (event.key === "Enter") handleLinkClick();
                }}
              >
                About
              </div>
              <div>
                <Link
                  className={
                    tabName === DEVELOPER_TAB
                      ? "nav-link text-uppercase active"
                      : "nav-link text-uppercase"
                  }
                  to="/developer"
                >
                  Developer
                </Link>
              </div>
              <div>
                <div
                  tabIndex="0"
                  role="button"
                  className="nav-link text-uppercase"
                  onClick={handlePrefMenu}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") handlePrefMenu(event);
                  }}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  Preferences
                  <ArrowDropDownIcon style={{ marginLeft: "8px", fontSize: "20px" }} />
                </div>
                {preferencesMenu}
              </div>
            </div>
          )}
        </Toolbar>
      </AppBar>
    </>
  );
}
